module.exports = __webpack_public_path__ + "img/linkd2-4.30f2a79f.webp";